import React, { useState } from 'react'
import styles from './settings-modal.module.scss'
import Button from 'src/components/button/Button'
import ToggleSwitch from 'src/components/toggleSwitch/ToggleSwitch'

interface IProps {
  close?: any
  ToggleSwitchLabel: string,
  checked: boolean
  handleClick: (value) => void
}

const SettingsModal: React.FunctionComponent<IProps> = ({ close, ToggleSwitchLabel, handleClick, checked }: IProps) => {
  const [toggleValue, setToggleValue] = useState(checked || false)
  return (
    <>
      <header className={styles.header}>
        <h4 className={styles.title}>Indstillinger</h4>
        <svg onClick={close} xmlns="http://www.w3.org/2000/svg" className="tw-h-5 tw-w-5 tw-ml-auto tw-cursor-pointer" viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z" clipRule="evenodd" />
        </svg>
      </header>
      <div className={styles.container}>
        <div className={styles.toggleSwitch}>
          <ToggleSwitch label={ToggleSwitchLabel} textSize='large' onChange={setToggleValue} checked={toggleValue} />
        </div>
      </div>
      <footer className={styles.footer}>
        <Button type='secondary' label='Annuller' modifiers='tw-mr-auto' handleClick={close} />
        <Button type='primary' label='Gem ændringer' handleClick={() => handleClick(toggleValue)} />
      </footer>
    </>
  )
}

export default SettingsModal
